
import { Box, IconButton, Typography } from '@mui/material';
import { useVideoCallLayoutStyles } from './styles';
import { Close } from '@mui/icons-material';
import { ScrollableView } from '@uplift/ui-v2';


export type VideoCallDrawerContentContainerProps = {
  title: string;
  onClose: () => void;
};

export const VideoCallDrawerContentContainer: React.FC<VideoCallDrawerContentContainerProps> = props => {
  const { classes } = useVideoCallLayoutStyles();

  return (
    <Box className={classes.drawerContentContainer}>
      <Box className={classes.drawerContentContainerHeader}>
        <Typography align="center" variant="h6">
          {props.title}
        </Typography>
        <IconButton type="button" onClick={() => props.onClose()}>
          <Close />
        </IconButton>
      </Box>
      <ScrollableView>
        {props.children}
      </ScrollableView>
    </Box>
  );
};
